/** @jsx jsx */
import { jsx, Button, Flex } from 'theme-ui';

const Buttons = ({ justifyContent, buttons, builderBlock }) => (
  <Flex
    sx={{
      flexDirection: ['column', 'column', 'row'],
      flexWrap: 'wrap',
      justifyContent,
    }}
  >
    {buttons.map((b) => (
      <Button
        as="a"
        key={`${builderBlock.id}-${b.linkUrl}`}
        href={b.linkUrl}
        variant={b.variant}
        sx={{
          // For backwards compatibility
          textTransform: (b.uppercase === false ? 'none' : 'uppercase'),
        }}
      >
        {b.label}
        
        {/* Mando button style with arrow */}
        {b.variant === 'primaryMando' &&
        <svg width="20" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-4.80825e-07 0L5.5 5.5L0 11L-4.80825e-07 0Z" fill="black"/>
        </svg>        
        }
      </Button>
    ))}
  </Flex>
);

export default Buttons;
